import styled from 'styled-components';

const Placeholder = styled.div`
  border: 0.125rem dashed #b4b4b4;
  width: ${props => props.width || '100%'};
  height: ${props => props.height};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #747474;
  border-radius: 0.625rem;
`;

export default Placeholder;